import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ startDate, endDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [status, setStatus] = useState('');

  useEffect(() => {
    const calculateTimeLeft = () => {
      if (!startDate || !endDate) return;

      const now = new Date().getTime();
      const start = new Date(startDate.replace(' ', 'T')).getTime();
      const end = new Date(endDate.replace(' ', 'T')).getTime();

      let targetDate;
      let currentStatus = '';

      if (now < start) {
        targetDate = start;
        currentStatus = 'Registration Opens In: ';
      } else if (now <= end) {
        targetDate = end;
        currentStatus = 'Registration Closes In: ';
      } else {
        currentStatus = 'Closed';
        targetDate = null;
      }

      setStatus(currentStatus);

      if (targetDate) {
        const difference = targetDate - now;
        
        if (difference > 0) {
          setTimeLeft({
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60)
          });
        }
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft(); // initial call
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [startDate, endDate]);

  if (status === 'Closed') {
    return <div className="mt-2 mb-2 text-danger fw-bold text-center">Registration Closed</div>;
  }

  return (
    <div className="countdown-timer">
      <p className="mb-2 fw-bold text-center" style={{ fontSize: '12px', color: '#ed3535' }}>{status}</p>
      <div className="d-flex justify-content-center gap-2">
        <div className="text-center">
          <div className="bg-transparent rounded shadow-sm" style={{ padding: '8px 12px', minWidth: '55px', border: '2px solid #135a94' }}>
            <h5 className="mb-0 fw-bold" style={{ fontSize: '18px', color: '#135a94' }}>{timeLeft.days}</h5>
            <small className="d-block mt-1 fw-bold" style={{ fontSize: '11px', lineHeight: '1', color: '#555' }}>Days</small>
          </div>
        </div>
        <div className="text-center">
          <div className="bg-transparent rounded shadow-sm" style={{ padding: '8px 12px', minWidth: '55px', border: '2px solid #135a94' }}>
            <h5 className="mb-0 fw-bold" style={{ fontSize: '18px', color: '#135a94' }}>{timeLeft.hours}</h5>
            <small className="d-block mt-1 fw-bold" style={{ fontSize: '11px', lineHeight: '1', color: '#555' }}>Hours</small>
          </div>
        </div>
        <div className="text-center">
          <div className="bg-transparent rounded shadow-sm" style={{ padding: '8px 12px', minWidth: '55px', border: '2px solid #135a94' }}>
            <h5 className="mb-0 fw-bold" style={{ fontSize: '18px', color: '#135a94' }}>{timeLeft.minutes}</h5>
            <small className="d-block mt-1 fw-bold" style={{ fontSize: '11px', lineHeight: '1', color: '#555' }}>Min</small>
          </div>
        </div>
        <div className="text-center">
          <div className="bg-transparent rounded shadow-sm" style={{ padding: '8px 12px', minWidth: '55px', border: '2px solid #135a94' }}>
            <h5 className="mb-0 fw-bold" style={{ fontSize: '18px', color: '#135a94' }}>{timeLeft.seconds}</h5>
            <small className="d-block mt-1 fw-bold" style={{ fontSize: '11px', lineHeight: '1', color: '#555' }}>Sec</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
